import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import BlogLoginForm from './blog-login-form'
import { updateLinksInText, addImgSrc } from '../../lib/blog-utils/blog-post-formatter'
import { getSlicedPost } from '../../lib/blog-utils/blog-post-preview'
import { insertBlogMetaData } from '../../lib/blog-utils/blog-utils'
import { BlogPost } from '../../models/BlogPost'
import moment from 'moment'
import { useParameters,useTranslation } from '../../utils'
import { Link } from 'react-router-dom'
import {
  prepareCategories,
  blogCategoryUrl,
  useAddTargetBlankAndUrls,
  removeOldUrlsDivsAndAnchors,
  hideBlockByClassName
} from './utils'
import { useSupportedLanguage } from './menu-bar/menu'
import metrics from '../../lib/metrics'
import MetaTags from 'react-meta-tags' 

const abTestingValue = Math.random().toPrecision(2)
// localStorage.getItem('abTestingValue') ? "" : localStorage.setItem('abTestingValue', abTestingValue)
// const abTestingException = localStorage.getItem('abTestingValue') ?? 0
const abTestingException = "0"

export function SingleBlogPost({ post, isLoggedIn, bottomRef }: {
  post: BlogPost,
  isLoggedIn: boolean,
  bottomRef?: React.RefObject<HTMLDivElement> | ((node: HTMLDivElement) => void)
}) {
  function onPropertyClick() {
    metrics.trackPropertyPageView()
  }
  function addAnalytics() {
    let properties = document.querySelectorAll('.crp-tile.ftg-')
    properties.forEach((item) => {
      item.addEventListener('click', onPropertyClick)
    })
  }
  useEffect(addAnalytics, []);
  function getContentForLoginState(post: BlogPost) {
    const postContent = updateLinksInText(addImgSrc(post.content?.rendered!))
    // if (!isLoggedIn && abTestingException > "0.5") {
    //   return getSlicedPost(postContent, false)
    // }
    // else if (!isLoggedIn && abTestingException <= "0.5") {
    //   return getSlicedPost(postContent, true)
    // }
    return postContent
  }
  const routeParam = useParameters<{
    searchType?: "category" | "tag" | "text",
    searchText?: string,
    lang: string,
  }>();
  const notSignedIn = !isLoggedIn
  const postContent = getContentForLoginState(post)
  useSupportedLanguage("post", post);
  const { t } = useTranslation();
  const { keyCategory, displayCategories } = prepareCategories(post.categories);
  const url = encodeURI(`${HOST_URL}/${routeParam.lang}/content/${post.slug}`)
  removeOldUrlsDivsAndAnchors(true, `${postContent}`)
  useAddTargetBlankAndUrls(".blog-post a", ".crp-tile.ftg- ", `${postContent}`)
  hideBlockByClassName(".ftg-items", postContent)
  return (
    <div className='blog-post'>
    <MetaTags>
      <title>{post.title ? post.title.rendered! : t('seo_title_home')}</title>
    </MetaTags>
      {keyCategory && <Link to={blogCategoryUrl(routeParam.lang, keyCategory.slug)}><h4 dangerouslySetInnerHTML={{ __html: keyCategory.name }}></h4></Link>}
      <h1 dangerouslySetInnerHTML={{ __html: post.title?.rendered! }} />
      <div className='meta-wrapper'>
        <div className='blog-post-date'>{moment(post.modified).locale(routeParam.lang ?? 'en').format("MMM D YYYY")}</div>
        {displayCategories && 
          <div className='article-tags blog-post-tags'>Tags: {displayCategories.map((c) =>
            <Link key={c.id} className='tag-link' to={blogCategoryUrl(routeParam.lang, c.slug)}
              dangerouslySetInnerHTML={{ __html: c.name }}></Link>)}
          </div>}
      </div>
      <img src={post.jetpack_featured_media_url} />
      <div dangerouslySetInnerHTML={{ __html: postContent }} />
      {/*{notSignedIn ?*/}
      {/*  <div className="blog-fader-loginFormContainer" >*/}
      {/*    <div className="blogPostfader"></div>*/}
      {/*    <BlogLoginForm />*/}
      {/*  </div> : null}*/}
        <div className="share-border-top" style={{ marginTop: notSignedIn ? '' : "30px" }} />
        {notSignedIn?
      <div className='blog-share' ><p>Share this article in:</p></div>:
      <div className='blog-share' ><p>Found this article helpful?</p>
      <p id='blog-share-sub-text'> Please share with your friends and family</p>
      </div>
    }
      <div className='share-wrapper'>
        <a rel='noopener noreferrer' target="_blank" className='share-button facebook' href={`https://facebook.com/sharer/sharer.php?u=${url}`}></a>
        <a rel='noopener noreferrer' target="_blank" className='share-button twitter' href={`https://twitter.com/share?url=${url}`}></a>
        <a rel='noopener noreferrer' target="_blank" className='share-button pinterest' href={`https://pinterest.com/pin/create/button/?url=${url}`}></a>
        <a rel='noopener noreferrer' target="_blank" className='share-button linkedin' href={`https://linkedin.com/sharing/share-offsite/?url=${url}`}></a>
      </div>
      <div className="border-bottom-separator" />
      <div ref={bottomRef}></div>
    </div>
  )
}

export default SingleBlogPost